import { Dispatch, SetStateAction, useEffect, useState } from "react";
import OpsDateUtils from "../utils/OpsDateUtils";
import useLocalStorage, { STORAGE_KEYS } from "./useLocalStorage";

export function useStoredDate(): [Date, Dispatch<SetStateAction<Date>>] {
  const [storedDate, setStoredDate] = useLocalStorage<string>(STORAGE_KEYS.STORED_DATE, "");
  const [date, setDate] = useState<Date>(() => (storedDate !== "" ? new Date(storedDate) : OpsDateUtils.getCurrentDay()));

  useEffect(() => {
    if (date && date.toString() !== storedDate) {
      setStoredDate(date.toString());
    }
  }, [date]); // eslint-disable-line react-hooks/exhaustive-deps

  return [date, setDate];
}

export function useMaxStoredDate(): [Date, Dispatch<SetStateAction<Date>>] {
  const [maxStoredDate, setMaxStoredDate] = useLocalStorage<string>(STORAGE_KEYS.MAX_STORED_DATE, "");
  const [date, setDate] = useState<Date>(() => (maxStoredDate !== "" ? new Date(maxStoredDate) : OpsDateUtils.getMaxDate()));

  useEffect(() => {
    if (date && date.toString() !== maxStoredDate) {
      setMaxStoredDate(date.toString());
    }
  }, [date]); // eslint-disable-line react-hooks/exhaustive-deps

  return [date, setDate];
}